import axios from 'axios';

const PICKS_KEY = 'ftc_letter_recs';
const CUSTOM_KEY = 'ftc_custom_letters';
export const CUSTOM_PICK = 'custom';

export const normName = (x) => String(x || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
const read = (k) => { try { return JSON.parse(localStorage.getItem(k) || '{}'); } catch (_e) { return {}; } };
const keysFor = (name) => [normName(name), normName(String(name || '').split(' - ')[0])];

// Saves the chosen letter per account (template key or 'custom') for the dispute letter wizard.
export const savePicks = (picks) => {
  const all = read(PICKS_KEY);
  picks.forEach(({ name, pick }) => { if (pick) keysFor(name).forEach((k) => { all[k] = pick; }); });
  localStorage.setItem(PICKS_KEY, JSON.stringify(all));
};
export const pickFor = (name) => { const all = read(PICKS_KEY); return keysFor(name).map((k) => all[k]).find(Boolean) || null; };

export const saveCustomLetter = (name, data) => {
  const all = read(CUSTOM_KEY);
  all[normName(name)] = { ...data, account_name: name };
  localStorage.setItem(CUSTOM_KEY, JSON.stringify(all));
};
export const customLetterFor = (name) => { const all = read(CUSTOM_KEY); return keysFor(name).map((k) => all[k]).find(Boolean) || null; };

export const downloadCustomLetterPdf = async (c) => {
  const filename = `${c.account_name} custom dispute letter`;
  const r = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/dispute-letters/custom-pdf`,
    { letter: c.letter, filename }, { responseType: 'blob', timeout: 30000 });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = url; a.download = `${filename.replace(/[^A-Za-z0-9 _.-]/g, '')}.pdf`;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};
